// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { isPlatformIframe } from '../../platform/utils/platformDetailsUtils';

// Selectors
import { getIsCurrentVisibleBoardFetched } from '../../element/board/boardSelector';
import { getPlatformDetailsSelector } from '../../platform/platformSelector';

// Actions
import { userNavigate, guestNavigate } from '../../user/currentUserActions';

// Constants
import { UserNavigationOperation } from '../../../common/users/userNavigationTypes';

const mapStateToProps = createStructuredSelector({
    currentBoardIsFetched: getIsCurrentVisibleBoardFetched,
    platformDetails: getPlatformDetailsSelector,
});

const mapDispatchToProps = (dispatch) => ({
    sendUserNavigate: ({ currentUser, newBoardId, previousBoardId }) => {
        if (currentUser.get('isGuest')) {
            return dispatch(guestNavigate({ newBoardId, previousBoardId }));
        }

        return dispatch(
            userNavigate({
                userId: currentUser.get('_id'),
                newBoardId,
                previousBoardId,
                operation: UserNavigationOperation.GENERAL,
            }),
        );
    },
});

/**
 * This component is being used to separate the redirection logic out of the WorkspaceInitContainer to account
 * for the scenario that the root URL is loaded (e.g. www.milanote.com) because sub routes are not invoked in
 * this version of React Router when the current route matches exactly ('/').
 */
export default (DecoratedComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class WorkspaceNavigationDecorator extends React.Component {
        constructor(props) {
            super(props);

            this.awaitingNavigationToDispatch = false;
            this.previousBoardId = null;
        }

        componentWillMount() {
            const { currentBoardId, socketConnected, isGuest, currentBoardIsFetched } = this.props;

            if (!currentBoardId) return;

            this.awaitingNavigationToDispatch = true;

            if (!socketConnected && !isGuest) return;

            if (currentBoardIsFetched) this.sendNavigationEvent(this.props);
        }

        componentWillReceiveProps(nextProps) {
            const { currentBoardId, socketConnected, isGuest, platformDetails } = nextProps;

            if (!currentBoardId || (!socketConnected && !isGuest && !isPlatformIframe(platformDetails))) return;

            if (this.props.currentBoardId !== currentBoardId) {
                this.previousBoardId = this.props.currentBoardId;
                this.awaitingNavigationToDispatch = true;
            }

            if (this.awaitingNavigationToDispatch && nextProps.currentBoardIsFetched) {
                this.sendNavigationEvent(nextProps);
            }
        }

        sendNavigationEvent = (nextProps) => {
            if (!this.awaitingNavigationToDispatch) return;

            const { sendUserNavigate, currentBoardId, currentUser } = nextProps;

            this.awaitingNavigationToDispatch = false;

            sendUserNavigate({
                currentUser,
                newBoardId: currentBoardId,
                previousBoardId: this.previousBoardId,
            });
        };

        render() {
            return <DecoratedComponent {...this.props} />;
        }
    }

    WorkspaceNavigationDecorator.propTypes = {
        currentBoardId: PropTypes.string,
        currentUser: PropTypes.object,
        socketConnected: PropTypes.bool,
        sendUserNavigate: PropTypes.func,
        currentBoardIsFetched: PropTypes.bool,
        isGuest: PropTypes.bool,
        platformDetails: PropTypes.object,
    };

    return WorkspaceNavigationDecorator;
};
